import { render, staticRenderFns } from "./ShowUserPage.vue?vue&type=template&id=a40ef6ea&scoped=true&"
import script from "./ShowUserPage.vue?vue&type=script&lang=js&"
export * from "./ShowUserPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40ef6ea",
  null
  
)

export default component.exports